import React, { useState } from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider, useQuery } from '@apollo/react-hooks';
// import styled from 'styled-components';
import { gql } from 'apollo-boost';

import Layout from '../../../components/layout';
import { SettingProvider } from '../../../lib/context/settings';
import { AdsProvider } from '../../../lib/context/ads';
import wpImageUrl from '../../../lib/wp-image-url';
import { Button, Input, Skeleton } from 'antd';
import Center from '../../../stories/helpers/center';
import format from 'date-fns/format';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const PRESS_RELEASE_QUERY = gql`
  query PressReleaseQuery {
    pressReleases(
      where: { status: PUBLISH, orderby: { field: DATE, order: DESC } }
      first: 15
    ) {
      nodes {
        dateGmt
        uri
        title
      }
    }
  }
`;

const loadingItems = new Array(2).fill('').map((_, idx) => (
  <div key={idx}>
    <Skeleton active />
  </div>
));

type PressReleaseEntryProps = {
  dateGmt: string;
  uri: string;
  title: string;
};

type PressReleasesListResult = {
  pressReleases: {
    nodes: Array<PressReleaseEntryProps>;
  };
};

const PressReleaseEntry: React.FC<PressReleaseEntryProps> = ({
  dateGmt,
  uri,
  title,
}) => {
  return (
    <a href={uri} style={{ display: 'block', marginBottom: 10 }}>
      <h2 style={{ margin: 0 }}>{title}</h2>
      <div>{format(new Date(dateGmt), 'MMMM do, yyyy')}</div>
    </a>
  );
};

const SignUpForm: React.FC<any> = () => {
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Sign Up Form</h2>
      <form className="vr-signup-form" id="vr-signup-form-23089744185277">
        <div className="vr-field">
          <label>First Name</label>
          <Input name="first_name" />
        </div>
        <div className="vr-field">
          <label>Last Name</label>
          <Input name="last_name" />
        </div>
        <div className="vr-field">
          <span className="vr-required">*</span>
          <label>Email Address</label>
          <Input type="email" name="email_address" required />
        </div>
        <div className="vr-field">
          <label>Company</label>
          <Input name="company_name" />
        </div>
        <div className="vr-field">
          <label>City</label>
          <Input name="locality" />
        </div>
        <div className="vr-field">
          <label>State/Region</label>
          <Input name="region" />
        </div>
        <div className="vr-submit">
          <div className="vr-notice"></div>
          <Button type="primary" danger htmlType="submit">
            Sign Up
          </Button>
        </div>
      </form>
      <link
        media="all"
        rel="stylesheet"
        type="text/css"
        href="https://vr2.verticalresponse.com/signup_forms/signup_forms.embedded-2.css"
      />
      <script
        type="text/javascript"
        src="https://vr2.verticalresponse.com/signup_forms/signup_forms.embedded-2.js"
      ></script>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `if (typeof VR !== "undefined" && typeof VR.SignupForm !== "undefined") { new VR.SignupForm({ id: "23089744185277", element: "vr-signup-form-23089744185277", endpoint: "https://vr2.verticalresponse.com/se/", submitLabel: "Submitting...", invalidEmailMessage: "Invalid email address", generalErrorMessage: "An error occurred", notFoundMessage: "Signup form not found", successMessage: "Success!", nonMailableMessage: "Nonmailable address"}); }`,
        }}
      ></script>
    </div>
  );
};

const PressReleasesList: React.FC<any> = () => {
  const { loading, error, data } = useQuery<PressReleasesListResult>(
    PRESS_RELEASE_QUERY
  );
  const [signUpVisible, setSignUpVisible] = useState(false);

  const toggleSignUpForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setSignUpVisible((v) => !v);
  };

  return (
    <Layout key={`${typeof window}`}>
      <div
        style={{
          backgroundImage: `url(${wpImageUrl(
            'https://aaacdndev.blob.core.windows.net/wordpress/about/press-release-hero.jpg'
          )})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          height: 300,
        }}
      />
      <h1 style={{ textAlign: 'center', marginTop: '.5em' }}>Press Releases</h1>
      <div>
        <Center>
          <div style={{ maxWidth: 1200, width: '80%', marginBottom: 25 }}>
            {loading ? loadingItems : null}
            {error ? error.message : null}
            {!loading && !error && data
              ? data.pressReleases.nodes.map((i) => (
                  <PressReleaseEntry {...i} key={i.uri} />
                ))
              : null}
            <div style={{ marginTop: 30 }}>
              <strong>
                <div>
                  <h2>Tiffany Wright</h2>
                  Public Relations Manager
                  <br />
                  <a href="mailto:tmwright@aaacarolinas.com">
                    tmwright@aaacarolinas.com
                  </a>
                  <br />
                  <a href="tel:704-737-8306">Work : 704-737-8306</a>
                  <br />
                  <a href="tel:704-569-7768">Cell : 704-569-7768</a>
                </div>
              </strong>
              <a onClick={toggleSignUpForm}>Sign Up?</a>
              {signUpVisible ? <SignUpForm /> : null}
            </div>
          </div>
        </Center>
      </div>
    </Layout>
  );
};

const PressReleasesListPage: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <PressReleasesList />
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default PressReleasesListPage;
